class BESSAppCreditDependencyEvent extends BESSAppDependencyEvent {
 static name = "BESSAppCreditDependencyEvent";

    static eventFor(creditCode) {
        return BESSAppCreditDependencyEvent.name + "_" + creditCode;
    }

    constructor(creditCode, enabled, changing = false) {
        super(BESSAppCreditDependencyEvent.eventFor(creditCode), enabled, changing);
    }
}